<template>
    <v-card>
        <v-snackbar
            :color="notifyColor"
            :timeout="5000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-form ref="batchGenForm" v-model="isValid">
            <v-card-text>
                <v-container class="pb-0" fluid>
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-divider></v-divider>
                            <v-card-title
                                >4 MOTOR VEHICLE ACCIDENT DETAILS</v-card-title
                            >
                            <v-col cols="12"
                                ><v-btn
                                    color="secondary"
                                    @click="showIncidentForm = true"
                                    >View Incident</v-btn
                                ></v-col
                            >
                            <v-divider></v-divider>
                            <v-card-title
                                >5 INJURED'S / DECEASED'S DETAILS</v-card-title
                            >
                            <v-col cols="12"
                                ><v-btn
                                    :disabled="!this.claim.patientId"
                                    color="secondary"
                                    @click="showPatientForm = true"
                                    >View Patient</v-btn
                                ></v-col
                            >
                            <v-divider></v-divider>
                            <v-card-title>6 COMPENSATION CLAIMED</v-card-title>
                            <v-col cols="12">
                                <v-switch
                                    label="Emergency"
                                    flase-value=""
                                    true-value="x"
                                    v-model="cbrdto._6Emergency"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12">
                                <v-switch
                                    label="Non Emergency"
                                    flase-value=""
                                    true-value="x"
                                    v-model="cbrdto._6NonEmergency"
                                ></v-switch>
                            </v-col>
                            <span
                                v-show="
                                    cbrdto._6NonEmergency && cbrdto._6Emergency
                                "
                            >
                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[]"
                                        type="number"
                                        prefix="R"
                                        min="0"
                                        @change="emergencyChange"
                                        label="Emergency amount"
                                        v-model.number="
                                            cbrdto._6AmountEmergency
                                        "
                                        ref="_6AmountEmergency"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[]"
                                        type="number"
                                        prefix="R"
                                        min="0"
                                        @change="nonEmergencyChange"
                                        label="Non emergency amount"
                                        v-model.number="
                                            cbrdto._6AmountNonEmergency
                                        "
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        readonly
                                        :rules="[]"
                                        type="number"
                                        prefix="R"
                                        min="0"
                                        label="Total amount"
                                        v-model.number="
                                            this.claim.totalAmountClaimed
                                        "
                                    ></v-text-field>
                                </v-col>
                            </span>

                            <v-col cols="12"
                                ><v-btn color="secondary" @click="openAccounts"
                                    >View Accounts</v-btn
                                ></v-col
                            >
                            <v-divider></v-divider>
                            <span v-show="cbrdto._6Emergency">
                                <v-card-title
                                    >7 PAST EMERGENCY MEDICAL
                                    TREATMENT</v-card-title
                                >
                                <v-col cols="12">
                                    <v-switch
                                        label="Emergency transport"
                                        flase-value=""
                                        true-value="x"
                                        v-model="cbrdto._7Transport"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        label="Hospital care"
                                        flase-value=""
                                        true-value="x"
                                        v-model="cbrdto._7Hospital"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        label="ICU"
                                        flase-value=""
                                        true-value="x"
                                        v-model="cbrdto._7Icu"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        label="Other"
                                        flase-value=""
                                        true-value="x"
                                        v-model="cbrdto._7Other"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Other detail"
                                        v-model="cbrdto._7OtherText"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 1"
                                        v-model="cbrdto._7IcdCode1"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 2"
                                        v-model="cbrdto._7IcdCode2"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 3"
                                        v-model="cbrdto._7IcdCode3"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 4"
                                        v-model="cbrdto._7IcdCode4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 5"
                                        v-model="cbrdto._7IcdCode5"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 6"
                                        v-model="cbrdto._7IcdCode6"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 7"
                                        v-model="cbrdto._7IcdCode7"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 8"
                                        v-model="cbrdto._7IcdCode8"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 9"
                                        v-model="cbrdto._7IcdCode9"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 10"
                                        v-model="cbrdto._7IcdCode10"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 11"
                                        v-model="cbrdto._7IcdCode11"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 12"
                                        v-model="cbrdto._7IcdCode12"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12"
                                    ><v-btn
                                        color="secondary"
                                        @click="openAccounts"
                                        >View Accounts</v-btn
                                    ></v-col
                                >
                            </span>
                            <span v-show="cbrdto._6NonEmergency">
                                <v-divider></v-divider>
                                <v-card-title
                                    >8 PAST NON-EMERGENCY MEDICAL
                                    TREATMENT</v-card-title
                                >
                                <v-col cols="12">
                                    <v-switch
                                        label="Transport"
                                        flase-value=""
                                        true-value="x"
                                        v-model="cbrdto._8Transport"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        label="Hospital care"
                                        flase-value=""
                                        true-value="x"
                                        v-model="cbrdto._8Hospital"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        label="Other"
                                        flase-value=""
                                        true-value="x"
                                        v-model="cbrdto._8Other"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Other detail"
                                        v-model="cbrdto._8OtherText"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 1"
                                        v-model="cbrdto._8IcdCode1"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 2"
                                        v-model="cbrdto._8IcdCode2"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 3"
                                        v-model="cbrdto._8IcdCode3"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 4"
                                        v-model="cbrdto._8IcdCode4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 5"
                                        v-model="cbrdto._8IcdCode5"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 6"
                                        v-model="cbrdto._8IcdCode6"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 8"
                                        v-model="cbrdto._8IcdCode7"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 8"
                                        v-model="cbrdto._8IcdCode8"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Icd Code 9"
                                        v-model="cbrdto._8IcdCode9"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12"
                                    ><v-btn
                                        color="secondary"
                                        @click="openAccounts"
                                        >View Accounts</v-btn
                                    ></v-col
                                >
                            </span>
                            <v-divider></v-divider>
                            <v-card-title
                                >10 MEDICAL TREATMENT IN MEDICAL
                                FACILITY/HOSPITAL</v-card-title
                            >
                            <v-row no-gutters>
                                <v-col
                                    v-for="datePickerId in datePickerFor"
                                    :key="datePickerId"
                                    cols="12"
                                >
                                    <v-menu
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        min-width="290px"
                                        offset-y
                                        transition="scale-transition"
                                        v-model="dateMenus[datePickerId]"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-row no-gutters>
                                                <v-col cols="6">
                                                    <v-text-field
                                                        :label="
                                                            datePickerId +
                                                                1 +
                                                                '. Admitted ~ Discharged'
                                                        "
                                                        prepend-icon="mdi-calendar-month"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-model="
                                                            displayDates[
                                                                datePickerId
                                                            ]
                                                        "
                                                        v-on="on"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="1"></v-col>
                                                <v-col cols="1"
                                                    ><v-btn
                                                        class="mt-2"
                                                        icon
                                                        @click="
                                                            {
                                                                inputDates[
                                                                    datePickerId
                                                                ].splice(
                                                                    0,
                                                                    inputDates[
                                                                        datePickerId
                                                                    ].length
                                                                );
                                                                displayDates[
                                                                    datePickerId
                                                                ] = '';
                                                            }
                                                        "
                                                        ><v-icon dark
                                                            >mdi-close</v-icon
                                                        ></v-btn
                                                    ></v-col
                                                >
                                            </v-row>
                                        </template>
                                        <v-date-picker
                                            @change="
                                                dateMenus[datePickerId] = false
                                            "
                                            @input="displayDate(datePickerId)"
                                            color="secondary"
                                            range
                                            v-model="inputDates[datePickerId]"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12"
                                    ><v-btn
                                        color="secondary"
                                        @click="openAccounts"
                                        >View Accounts</v-btn
                                    ></v-col
                                >
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >Close</v-btn
                        >
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isGeneratingClaimBatch"
                            @click="generateClaimBatch()"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >Generate</v-btn
                        >
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="showIncidentForm"
        >
            <v-sheet class="base-background" min-height="100%">
                <v-toolbar color="secondary darken-1" dark>
                    <v-btn @click="showIncidentForm = false" dark icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Incident Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row align="center" justify="center" v-if="true">
                        <IncidentForm
                            :incident-id="this.claim.incidentId"
                            :key="this.claim.incidentId"
                            @close="showIncidentForm = false"
                            :providers="providers"
                            :sapd-metros="sapdMetros"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>
        <v-dialog
            width="800"
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="showPatientForm"
            ><PatientForm
                :patient-id="this.claim.patientId"
                :key="this.claim.patientId"
                @close="showPatientForm = false"
            />
        </v-dialog>
    </v-card>
</template>

<script>
import uuid4 from "../../helpers/uuid4";
import ClaimBatchRequestDto from "../../models/dtos/ClaimBatchRequestDto.model";
import IncidentForm from "./IncidentForm.vue";
import PatientForm from "./PatientForm.vue";
//import dateToString from "../../helpers/dateToString";
export default {
    props: ["claimId", "claim"],
    created: async function() {},
    components: {
        IncidentForm,
        PatientForm,
        //
    },
    data() {
        return {
            datePickerFor: [0, 1, 2, 3, 4, 5, 6, 7, 8],
            dateMenu1: false,
            inputDates: [[], [], [], [], [], [], [], [], []],
            displayDates: [[], [], [], [], [], [], [], [], []],
            dateMenus: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
            ],
            providers: [],
            sapdMetros: [],
            showIncidentForm: false,
            showPatientForm: false,
            cbrdto: new ClaimBatchRequestDto(),
            populating: true,
            populatingFailure: true,
            fundingTypes: [],
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            isGeneratingClaimBatch: null,
            requestId: uuid4(),
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: (v) => !!v || "required",
            lengthRule: (limit) => (v) =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            numericReg: /^\d+$/,
            isNumber: (n) => this.numericReg.test(n) || "not a whole number",
        };
    },
    mounted: async function() {
        this.providers = await this.$store.dispatch("providers/getlist");
        this.sapdMetros = await this.$store.dispatch("sapdmetros/getlist");
    },
    computed: {
        //
    },
    methods: {
        displayDate(datepickerId) {
            this.displayDates[datepickerId] =
                this.inputDates[datepickerId][0] +
                " ~ " +
                (typeof this.inputDates[datepickerId][1] === 'undefined' ? '': this.inputDates[datepickerId][1]);
        },
        nonEmergencyChange() {
            if (
                this.cbrdto._6AmountNonEmergency > this.claim.totalAmountClaimed
            )
                this.cbrdto._6AmountNonEmergency = this.claim.totalAmountClaimed;
            else
                this.cbrdto._6AmountNonEmergency = parseFloat(
                    this.cbrdto._6AmountNonEmergency.toFixed(2)
                );

            this.cbrdto._6AmountEmergency = parseFloat(
                (
                    this.claim.totalAmountClaimed -
                    this.cbrdto._6AmountNonEmergency
                ).toFixed(2)
            );
        },
        emergencyChange() {
            if (this.cbrdto._6AmountEmergency > this.claim.totalAmountClaimed)
                this.cbrdto._6AmountEmergency = this.claim.totalAmountClaimed;
            else
                this.cbrdto._6AmountEmergency = parseFloat(
                    this.cbrdto._6AmountEmergency.toFixed(2)
                );

            this.cbrdto._6AmountNonEmergency = parseFloat(
                (
                    this.claim.totalAmountClaimed -
                    this.cbrdto._6AmountEmergency
                ).toFixed(2)
            );
        },
        openAccounts() {
            const routeData = this.$router.resolve({ name: "Accounts" });
            window.open(routeData.href + "/" + this.claimId, "_blank");
        },
        //emitters      ------------------------------------------------------------
        closeForm() {
            this.$emit("close");
        },
        generated(response) {
            this.$emit("generated", response);
        },
        notifyInternal(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        notify(message, color) {
            this.$emit("notify", message, color);
        },
        validateForm() {
            this.isValid = this.$refs.batchGenForm.validate();
            return this.isValid;
        },
        validationError(message) {
            this.notify(message, "error");
            this.isLoading = false;
            this.isGeneratingClaimBatch = false;
        },
        //generate batchfile
        generateClaimBatch() {
            this.isLoading = true;
            this.isGeneratingClaimBatch = true;
            if (
                this.cbrdto._6Emergency &&
                this.cbrdto._6NonEmergency &&
                this.cbrdto._6AmountEmergency +
                    this.cbrdto._6AmountNonEmergency !=
                    this.claim.totalAmountClaimed
            ) {
                this.validationError(
                    "Emergency and non-emergency claim amounts should add up to total claim value."
                );
                return;
            }

            if (!this.cbrdto._6Emergency && !this.cbrdto._6NonEmergency) {
                this.validationError(
                    "Either or both emergency and non-emergency must be selected."
                );
                return;
            }

            for (let i = 0; i < this.datePickerFor.length; i++) {
                if (
                    typeof this.inputDates[i] === "undefined" ||
                    this.inputDates[i] === null ||
                    this.inputDates[i].length == 0
                ) {
                    //
                    this.cbrdto["_10Admitted" + i] = "";
                    this.cbrdto["_10Discharged" + i] = "";
                } else if (this.inputDates[i].length == 1) {
                    this.validationError(
                        "Admitted and Discharged dates need to specify a date range"
                    );
                    return;
                } else if (this.inputDates[i].length == 2) {
                    if (this.inputDates[i][0] > this.inputDates[i][1]) {
                        this.validationError(
                            "Admitted and Discharged dates need to specify a date range"
                        );
                        return;
                    } else {
                        this.cbrdto["_10Admitted" + i] = this.inputDates[i][0];
                        this.cbrdto["_10Discharged" + i] = this.inputDates[
                            i
                        ][1];
                    }
                }
            }

            if (this.cbrdto._6Emergency == false) {
                this.cbrdto._7Transport = false;
                this.cbrdto._7Hospital = false;
                this.cbrdto._7Icu = false;
                this.cbrdto._7Other = false;
                this.cbrdto._7OtherText = "";
                this.cbrdto._7IcdCode1 = "";
                this.cbrdto._7IcdCode2 = "";
                this.cbrdto._7IcdCode3 = "";
                this.cbrdto._7IcdCode4 = "";
                this.cbrdto._7IcdCode5 = "";
                this.cbrdto._7IcdCode6 = "";
                this.cbrdto._7IcdCode7 = "";
                this.cbrdto._7IcdCode8 = "";
                this.cbrdto._7IcdCode9 = "";
                this.cbrdto._7IcdCode10 = "";
                this.cbrdto._7IcdCode11 = "";
                this.cbrdto._7IcdCode12 = "";
            }

            if (this.cbrdto._6NonEmergency == false) {
                this.cbrdto._8Transport = false;
                this.cbrdto._8Hospital = false;
                this.cbrdto._8Other = false;
                this.cbrdto._8OtherText = "";
                this.cbrdto._8IcdCode1 = "";
                this.cbrdto._8IcdCode2 = "";
                this.cbrdto._8IcdCode3 = "";
                this.cbrdto._8IcdCode4 = "";
                this.cbrdto._8IcdCode5 = "";
                this.cbrdto._8IcdCode6 = "";
                this.cbrdto._8IcdCode7 = "";
                this.cbrdto._8IcdCode8 = "";
                this.cbrdto._8IcdCode9 = "";
            }

            this.cbrdto._6Emergency = this.cbrdto._6Emergency ? "x" : "";
            this.cbrdto._6NonEmergency = this.cbrdto._6NonEmergency ? "x" : "";

            this.cbrdto._7Transport = this.cbrdto._7Transport ? "x" : "";
            this.cbrdto._7Hospital = this.cbrdto._7Hospital ? "x" : "";
            this.cbrdto._7Icu = this.cbrdto._7Icu ? "x" : "";
            this.cbrdto._7Other = this.cbrdto._7Other ? "x" : "";

            /*
            this.cbrdto._7TreatmentPlan1 =
                this.cbrdto._7IcdCode1 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan2 =
                this.cbrdto._7IcdCode2 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan3 =
                this.cbrdto._7IcdCode3 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan4 =
                this.cbrdto._7IcdCode4 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan5 =
                this.cbrdto._7IcdCode5 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan6 =
                this.cbrdto._7IcdCode6 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan7 =
                this.cbrdto._7IcdCode7 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan8 =
                this.cbrdto._7IcdCode8 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan9 =
                this.cbrdto._7IcdCode9 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan10 =
                this.cbrdto._7IcdCode10 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan11 =
                this.cbrdto._7IcdCode11 != "" ? "See attached documents" : "";
            this.cbrdto._7TreatmentPlan12 =
                this.cbrdto._7IcdCode12 != "" ? "See attached documents" : "";
                */
            this.cbrdto._7TreatmentPlan1 =
                this.cbrdto._7IcdCode1 != "" ||
                this.cbrdto._7IcdCode2 != "" ||
                this.cbrdto._7IcdCode3 != "" ||
                this.cbrdto._7IcdCode4 != "" ||
                this.cbrdto._7IcdCode5 != "" ||
                this.cbrdto._7IcdCode6 != "" ||
                this.cbrdto._7IcdCode7 != "" ||
                this.cbrdto._7IcdCode8 != "" ||
                this.cbrdto._7IcdCode9 != "" ||
                this.cbrdto._7IcdCode10 != "" ||
                this.cbrdto._7IcdCode11 != "" ||
                this.cbrdto._7IcdCode12 != ""
                    ? "See attached documents"
                    : "";

            this.cbrdto._8Transport = this.cbrdto._8Transport ? "x" : "";
            this.cbrdto._8Hospital = this.cbrdto._8Hospital ? "x" : "";
            this.cbrdto._8Other = this.cbrdto._8Other ? "x" : "";

            /*
            this.cbrdto._8TreatmentPlan1 =
                this.cbrdto._8IcdCode1 != "" ? "See attached documents" : "";
            this.cbrdto._8TreatmentPlan2 =
                this.cbrdto._8IcdCode2 != "" ? "See attached documents" : "";
            this.cbrdto._8TreatmentPlan3 =
                this.cbrdto._8IcdCode3 != "" ? "See attached documents" : "";
            this.cbrdto._8TreatmentPlan4 =
                this.cbrdto._8IcdCode4 != "" ? "See attached documents" : "";
            this.cbrdto._8TreatmentPlan5 =
                this.cbrdto._8IcdCode5 != "" ? "See attached documents" : "";
            this.cbrdto._8TreatmentPlan6 =
                this.cbrdto._8IcdCode6 != "" ? "See attached documents" : "";
            this.cbrdto._8TreatmentPlan7 =
                this.cbrdto._8IcdCode8 != "" ? "See attached documents" : "";
            this.cbrdto._8TreatmentPlan8 =
                this.cbrdto._8IcdCode8 != "" ? "See attached documents" : "";
            this.cbrdto._8TreatmentPlan9 =
                this.cbrdto._8IcdCode9 != "" ? "See attached documents" : "";
                */
            this.cbrdto._8TreatmentPlan1 =
                this.cbrdto._8IcdCode1 != "" ||
                this.cbrdto._8IcdCode2 != "" ||
                this.cbrdto._8IcdCode3 != "" ||
                this.cbrdto._8IcdCode4 != "" ||
                this.cbrdto._8IcdCode5 != "" ||
                this.cbrdto._8IcdCode6 != "" ||
                this.cbrdto._8IcdCode7 != "" ||
                this.cbrdto._8IcdCode8 != "" ||
                this.cbrdto._8IcdCode9 != ""
                    ? "See attached documents"
                    : "";

            this.$store
                .dispatch("claims/generateClaimBatch", {
                    id: this.claimId,
                    body: this.cbrdto,
                })
                .then(
                    (response) => {
                        this.generated(response);
                        this.notifyInternal("Success", "success");
                    },
                    (error) => this.notify(error.response.data, "error")
                )
                .finally(this.doneGeneratingClaimBatch);
        },
        doneGeneratingClaimBatch() {
            this.isLoading = false;
            this.isGeneratingClaimBatch = false;
        },
    },
};
</script>

<style lang="stylus" scoped></style>
